export default "__VITE_ASSET__ZeiTHv21__"